import { atom } from "recoil";      
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist({
    key:'languageState',
    storage:sessionStorage,
});

type Language = {
    lang:`ja` | `en`,
    jaButtonColor:`white`|`darkslategrey`,
    enButtonColor:`darkslategrey`|`white`,
    isFirstSetting:boolean,
}
export const languageState = atom<Language>({
    key: "languageState",
    default:{
        lang:`ja`,
        jaButtonColor:`white`,
        enButtonColor:`darkslategrey`,
        isFirstSetting:false
    },
    effects_UNSTABLE:[persistAtom],
});